import { render, staticRenderFns } from "./ChainOverview.vue?vue&type=template&id=07bc1000"
import script from "./ChainOverview.vue?vue&type=script&lang=js"
export * from "./ChainOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports